import { render } from "./Nav.vue?vue&type=template&id=24ea7196&scoped=true"
const script = {}

import "./Nav.vue?vue&type=style&index=0&id=24ea7196&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ea7196"]])

export default __exports__